import { Component, Input, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { BaseComponent, UserService, EventBusService } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";

const EU_COUNTRIES = new Set(["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "GB", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE"]);

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "fui-footer",
  templateUrl: "footer.component.html",
  standalone: false,
})
export class FuiFooterComponent extends BaseComponent implements OnInit {
  public year: number = new Date().getFullYear();
  public showWithdrawal = false;
  constructor(
    userService: UserService,
    public appService: AppService
  ) {
    super(userService);
    this.userService.user$.pipe(takeUntilDestroyed()).subscribe((u) => (this.showWithdrawal = !!u?.country && EU_COUNTRIES.has(u.country)));
  }

  ngOnInit(): void {
    this.showWithdrawal = !!this.userService.user?.country && EU_COUNTRIES.has(this.userService.user.country);
  }
}
